import React from 'react'
import Link from 'gatsby-link'
import styled from 'styled-components'

const Foot = styled.footer`
    position: fixed;
    bottom: 0;
    right: 0;
    z-index: -1;
    padding: 20px;
    background-color: ${props => props.color};
    height: ${props => props.height}px;
    color: #dddddd;
    columns: 2 300px;
`

const Paragraph= styled.p`
    margin-bottom: 0.8rem;
`

const FLink = styled(Link)`
    color: #dddddd;
`

const Footer = ({ className, color, height }) => (
    <Foot className={className} color={color} height={height}>
        <Paragraph>Copyright 2018 Moritz Beck (Birkenstab)</Paragraph>
        <Paragraph><FLink to="/impressum">Impressum</FLink></Paragraph>
        <Paragraph><FLink to="/datenschutz">Datenschutzerklärung</FLink></Paragraph>
        <Paragraph><FLink to="/links">Links</FLink></Paragraph>
    </Foot>
)

export default Footer



// WEBPACK FOOTER //
// ./src/components/footer.js